module.exports = __webpack_public_path__ + "72c41e03a5c6f8aaf58107f5429bc3cf.svg";